import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Panel_admin.css';

const SECCIONES = ['inicio', 'publicaciones', 'estadisticas', 'videos'];

const getClaseEstado = (estado) => {
  const valor = (estado || '').toUpperCase();
  if (valor === 'APROBADA') return 'pnl-estado-aprobada';
  if (valor === 'PENDIENTE') return 'pnl-estado-pendiente';
  if (valor === 'RECHAZADA') return 'pnl-estado-rechazada';
  return '';
};

const construirUrlUpload = (idPublicacion, tipoOrigen, archivo) => {
  const sub = tipoOrigen === 'verificacion' ? 'Proceso_verificacion/' : '';
  return `${process.env.REACT_APP_UPLOADS_URL}/ID_${idPublicacion}/${sub}${archivo}`;
};

const PanelAdmin = () => {
  const navigate = useNavigate();
  const [seccion, setSeccion] = useState('inicio');
  const [tabPublicaciones, setTabPublicaciones] = useState('avisos');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [idInspeccionar, setIdInspeccionar] = useState('');
  const [mensajeInspeccionar, setMensajeInspeccionar] = useState('');
  const [cargandoInspeccionar, setCargandoInspeccionar] = useState(false);
  const [clicksTotales, setClicksTotales] = useState([]);
  const [cargandoClicks, setCargandoClicks] = useState(false);
  const [busquedaClicks, setBusquedaClicks] = useState('');
  const [detalleClicksId, setDetalleClicksId] = useState(null);
  const [detalleClicksAgrupar, setDetalleClicksAgrupar] = useState('dia');
  const [detalleClicksData, setDetalleClicksData] = useState([]);
  const [cargandoDetalleClicks, setCargandoDetalleClicks] = useState(false);

  const [historiasVistasTotales, setHistoriasVistasTotales] = useState([]);
  const [cargandoHistoriasVistas, setCargandoHistoriasVistas] = useState(false);
  const [busquedaHistoriasVistas, setBusquedaHistoriasVistas] = useState('');
  const [detalleHistoriasId, setDetalleHistoriasId] = useState(null);
  const [detalleHistoriasAgrupar, setDetalleHistoriasAgrupar] = useState('dia');
  const [detalleHistoriasVistasData, setDetalleHistoriasVistasData] = useState([]);
  const [cargandoDetalleHistoriasVistas, setCargandoDetalleHistoriasVistas] = useState(false);
  const [calMes, setCalMes] = useState(() => { const h = new Date(); return new Date(h.getFullYear(), h.getMonth(), 1); });
  const [rangoDesde, setRangoDesde] = useState(null);
  const [rangoHasta, setRangoHasta] = useState(null);
  const [calPrimerClic, setCalPrimerClic] = useState(null);


  const [avisos, setAvisos] = useState([]);
  const [cargandoAvisos, setCargandoAvisos] = useState(false);
  const [errorAvisos, setErrorAvisos] = useState('');
  const [paginaAvisos, setPaginaAvisos] = useState(1);
  const AVISOS_POR_PAGINA = 12;

  const [verificaciones, setVerificaciones] = useState([]);
  const [cargandoVerificaciones, setCargandoVerificaciones] = useState(false);
  const [errorVerificaciones, setErrorVerificaciones] = useState('');
  const [paginaVerificaciones, setPaginaVerificaciones] = useState(1);
  const [seleccionVerificaciones, setSeleccionVerificaciones] = useState({});
  const [enviandoVerificacion, setEnviandoVerificacion] = useState(null);

  const [saldos, setSaldos] = useState([]);
  const [cargandoSaldos, setCargandoSaldos] = useState(false);
  const [errorSaldos, setErrorSaldos] = useState('');
  const [paginaSaldos, setPaginaSaldos] = useState(1);
  const [seleccionSaldos, setSeleccionSaldos] = useState({});
  const [enviandoSaldo, setEnviandoSaldo] = useState(null);

  const [edicionPublicaciones, setEdicionPublicaciones] = useState([]);
  const [cargandoEdicion, setCargandoEdicion] = useState(false);
  const [errorEdicion, setErrorEdicion] = useState('');
  const [paginaEdicion, setPaginaEdicion] = useState(1);
  const [seleccionEdicion, setSeleccionEdicion] = useState({});
  const [enviandoEdicion, setEnviandoEdicion] = useState(null);

  const [videos, setVideos] = useState([]);
  const [cargandoVideos, setCargandoVideos] = useState(false);
  const [subiendoVideo, setSubiendoVideo] = useState(false);
  const [tituloVideo, setTituloVideo] = useState('');
  const [descripcionVideo, setDescripcionVideo] = useState('');
  const [archivoVideo, setArchivoVideo] = useState(null);
  const [mensajeVideo, setMensajeVideo] = useState('');
  const [editandoVideoId, setEditandoVideoId] = useState(null);
  const [tituloEdicion, setTituloEdicion] = useState('');
  const [descripcionEdicion, setDescripcionEdicion] = useState('');

  const [modalContenido, setModalContenido] = useState({
    abierto: false,
    tipoOrigen: null,
    item: null,
    cargando: false,
    fotos: [],
    videos: [],
    audios: [],
    fotoAmpliada: null,
    videoAmpliado: null,
    pantallaCompleta: null,
    pantallaCompletaTipo: null
  });

  const cargarVideos = async () => {
    setCargandoVideos(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/Videos_principales_get.php?limit=50`);
      const data = await res.json();
      setVideos(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Error cargando videos:', e);
    } finally {
      setCargandoVideos(false);
    }
  };

  const handleSubirVideo = async (e) => {
    e.preventDefault();
    setMensajeVideo('');

    if (!tituloVideo.trim() || !archivoVideo) {
      setMensajeVideo('Titulo y archivo de video son requeridos');
      return;
    }

    setSubiendoVideo(true);
    const formData = new FormData();
    formData.append('titulo', tituloVideo.trim());
    formData.append('descripcion', descripcionVideo.trim());
    formData.append('video', archivoVideo);

    try {
      const res = await fetch(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/admin_subir_video_principal.php`, {
        method: 'POST',
        credentials: 'include',
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        setMensajeVideo('Video subido correctamente');
        setTituloVideo('');
        setDescripcionVideo('');
        setArchivoVideo(null);
        cargarVideos();
      } else {
        setMensajeVideo(data.message || 'Error al subir el video');
      }
    } catch (e) {
      console.error('Error subiendo video:', e);
      setMensajeVideo('Error de conexion');
    } finally {
      setSubiendoVideo(false);
    }
  };

  const iniciarEdicionVideo = (video) => {
    setEditandoVideoId(video.ID);
    setTituloEdicion(video.Titulo);
    setDescripcionEdicion(video.Descripcion || '');
  };

  const guardarEdicionVideo = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/admin_editar_video_principal.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: editandoVideoId, titulo: tituloEdicion, descripcion: descripcionEdicion })
      });
      const data = await res.json();
      if (data.success) {
        setVideos(prev => prev.map(v => v.ID === editandoVideoId ? { ...v, Titulo: tituloEdicion, Descripcion: descripcionEdicion } : v));
        setEditandoVideoId(null);
      } else {
        alert(data.message || 'No se pudo actualizar');
      }
    } catch (e) {
      console.error('Error editando video:', e);
      alert('Error de conexion');
    }
  };

  const handleEliminarVideo = async (video) => {
    const confirmado = window.confirm(`Vas a eliminar el video "${video.Titulo}" de forma permanente. Esta accion no se puede deshacer. Confirmas?`);
    if (!confirmado) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_VIDEO_PRINCIPAL_URL}/admin_eliminar_video_principal.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: video.ID })
      });
      const data = await res.json();
      if (data.success) {
        setVideos(prev => prev.filter(v => v.ID !== video.ID));
      } else {
        alert(data.message || 'No se pudo eliminar el video');
      }
    } catch (e) {
      console.error('Error eliminando video:', e);
      alert('Error de conexion');
    }
  };

  useEffect(() => {
    const cargarUsuario = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_AUTH_ADMIN_URL}/check_session.php`, {
          credentials: 'include'
        });
        const data = await res.json();
        if (data.success && data.autenticado) {
          setNombreUsuario(data.nombre_usuario || '');
        }
      } catch (e) {
        console.error('Error cargando usuario:', e);
      }
    };
    cargarUsuario();
  }, []);

  const cargarAvisos = async () => {
    setCargandoAvisos(true);
    setErrorAvisos('');
    try {
      const res = await fetch(`${process.env.REACT_APP_ESTADO_PUBLICACIONES_URL}/admin_listar_avisos.php`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.success) {
        setAvisos(data.data);
      } else {
        setErrorAvisos(data.message || 'Error cargando avisos');
      }
    } catch (e) {
      console.error('Error cargando avisos:', e);
      setErrorAvisos('Error de conexion');
    } finally {
      setCargandoAvisos(false);
    }
  };

  useEffect(() => {
    if (seccion === 'publicaciones' && tabPublicaciones === 'avisos') {
      cargarAvisos();
    }
    if (seccion === 'publicaciones' && tabPublicaciones === 'verificacion') {
      cargarVerificaciones();
    }
    if (seccion === 'publicaciones' && tabPublicaciones === 'saldo') {
      cargarSaldos();
    }
    if (seccion === 'publicaciones' && tabPublicaciones === 'edicion') {
      cargarEdicionPublicaciones();
    }
    if (seccion === 'videos') {
      cargarVideos();
    }
    if (seccion === 'estadisticas') {
      cargarClicksTotales();
      cargarHistoriasVistasTotales();
    }
  }, [seccion, tabPublicaciones]);

  const cargarClicksTotales = async (busqueda) => {
    setCargandoClicks(true);
    try {
      const q = busqueda !== undefined ? busqueda : busquedaClicks;
      const url = q
        ? `${process.env.REACT_APP_ESTADO_PUBLICACIONES_URL}/admin_listar_clicks_contacto.php?busqueda=${encodeURIComponent(q)}`
        : `${process.env.REACT_APP_ESTADO_PUBLICACIONES_URL}/admin_listar_clicks_contacto.php`;
      const res = await fetch(url, { credentials: 'include' });
      const data = await res.json();
      if (data.success) {
        setClicksTotales(data.data);
      }
    } catch (e) {
      console.error('Error cargando estadisticas:', e);
    } finally {
      setCargandoClicks(false);
    }
  };

  const handleBuscarClicks = (e) => {
    e.preventDefault();
    cargarClicksTotales(busquedaClicks);
  };

  const formatDiaCompleto = (fechaStr) => {
    const d = new Date(fechaStr + 'T00:00:00');
    return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
  };

  const formatRangoSemana = (fechaInicioStr) => {
    const inicio = new Date(fechaInicioStr + 'T00:00:00');
    const fin = new Date(inicio);
    fin.setDate(fin.getDate() + 6);
    const opts = { weekday: 'long', day: 'numeric', month: 'short' };
    const fmt = (d) => d.toLocaleDateString('es-CL', opts).replace('.', '');
    return `${fmt(inicio)} a ${fmt(fin)}`;
  };

  const verDetalleClicks = async (idPublicacion, agrupar) => {
    setDetalleClicksId(idPublicacion);
    setDetalleClicksAgrupar(agrupar);
    setCargandoDetalleClicks(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_ESTADO_PUBLICACIONES_URL}/admin_listar_clicks_contacto.php?id_publicacion=${idPublicacion}&agrupar=${agrupar}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      if (data.success) {
        setDetalleClicksData(data.data);
      }
    } catch (e) {
      console.error('Error cargando detalle:', e);
    } finally {
      setCargandoDetalleClicks(false);
    }
  };

  const cerrarDetalleClicks = () => {
    setDetalleClicksId(null);
    setDetalleClicksData([]);
  };

  const cargarHistoriasVistasTotales = async (busqueda) => {
    setCargandoHistoriasVistas(true);
    try {
      const q = busqueda !== undefined ? busqueda : busquedaHistoriasVistas;
      const url = q
        ? `${process.env.REACT_APP_HISTORIAS_VIEWER_URL}/admin_listar_vistas_historias.php?busqueda=${encodeURIComponent(q)}`
        : `${process.env.REACT_APP_HISTORIAS_VIEWER_URL}/admin_listar_vistas_historias.php`;
      const res = await fetch(url, { credentials: 'include' });
      const data = await res.json();
      if (data.success) {
        setHistoriasVistasTotales(data.data);
      }
    } catch (e) {
      console.error('Error cargando vistas de historias:', e);
    } finally {
      setCargandoHistoriasVistas(false);
    }
  };

  const handleBuscarHistoriasVistas = (e) => {
    e.preventDefault();
    cargarHistoriasVistasTotales(busquedaHistoriasVistas);
  };

  const verDetalleHistoriasVistas = async (usuarioId, agrupar) => {
    setDetalleHistoriasId(usuarioId);
    setDetalleHistoriasAgrupar(agrupar);
    setCargandoDetalleHistoriasVistas(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_HISTORIAS_VIEWER_URL}/admin_listar_vistas_historias.php?usuario_id=${usuarioId}&agrupar=${agrupar}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      if (data.success) {
        setDetalleHistoriasVistasData(data.data);
      }
    } catch (e) {
      console.error('Error cargando detalle de vistas de historias:', e);
    } finally {
      setCargandoDetalleHistoriasVistas(false);
    }
  };

  const fmtISO = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };

  const parseISO = (s) => new Date(s + 'T00:00:00');

  const verDetalleHistoriasRango = async (usuarioId, desde, hasta, modo) => {
    setDetalleHistoriasId(usuarioId);
    setDetalleHistoriasAgrupar(modo);
    setRangoDesde(desde);
    setRangoHasta(hasta);
    setCargandoDetalleHistoriasVistas(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_HISTORIAS_VIEWER_URL}/admin_listar_vistas_historias.php?usuario_id=${usuarioId}&desde=${desde}&hasta=${hasta}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      if (data.success) {
        const porDia = {};
        data.data.forEach(r => { porDia[r.fecha_inicio] = r; });
        const filas = [];
        const cursor = parseISO(hasta);
        const inicio = parseISO(desde);
        while (cursor >= inicio) {
          const k = fmtISO(cursor);
          filas.push(porDia[k] || { periodo: k, fecha_inicio: k, foto: 0, video: 0 });
          cursor.setDate(cursor.getDate() - 1);
        }
        setDetalleHistoriasVistasData(filas);
      }
    } catch (e) {
      console.error('Error cargando rango de vistas de historias:', e);
    } finally {
      setCargandoDetalleHistoriasVistas(false);
    }
  };

  const verUltimos3DiasHistorias = (usuarioId) => {
    const hoy = new Date();
    const desde = new Date(hoy);
    desde.setDate(hoy.getDate() - 2);
    setCalPrimerClic(null);
    verDetalleHistoriasRango(usuarioId, fmtISO(desde), fmtISO(hoy), 'ultimos3');
  };

  const abrirSemanaHistorias = (usuarioId) => {
    setCalPrimerClic(null);
    setRangoDesde(null);
    setRangoHasta(null);
    verDetalleHistoriasVistas(usuarioId, 'semana');
  };

  const clicDiaCalendario = (iso) => {
    if (!calPrimerClic) {
      setCalPrimerClic(iso);
      verDetalleHistoriasRango(detalleHistoriasId, iso, iso, 'rango');
    } else {
      const a = calPrimerClic <= iso ? calPrimerClic : iso;
      const b = calPrimerClic <= iso ? iso : calPrimerClic;
      setCalPrimerClic(null);
      verDetalleHistoriasRango(detalleHistoriasId, a, b, 'rango');
    }
  };

  const seleccionarSemanaCompleta = () => {
    const base = parseISO(rangoDesde || fmtISO(new Date()));
    const lunes = new Date(base);
    lunes.setDate(base.getDate() - ((base.getDay() + 6) % 7));
    const domingo = new Date(lunes);
    domingo.setDate(lunes.getDate() + 6);
    setCalPrimerClic(null);
    verDetalleHistoriasRango(detalleHistoriasId, fmtISO(lunes), fmtISO(domingo), 'rango');
  };

  const diasDelCalendario = () => {
    const anio = calMes.getFullYear();
    const mes = calMes.getMonth();
    const vacios = (new Date(anio, mes, 1).getDay() + 6) % 7;
    const diasMes = new Date(anio, mes + 1, 0).getDate();
    const celdas = [];
    for (let i = 0; i < vacios; i++) celdas.push(null);
    for (let d = 1; d <= diasMes; d++) celdas.push(fmtISO(new Date(anio, mes, d)));
    return celdas;
  };

  const claseDiaCalendario = (iso) => {
    let clase = 'pnl-cal-dia';
    const enRango = detalleHistoriasAgrupar === 'rango' && rangoDesde && rangoHasta && iso >= rangoDesde && iso <= rangoHasta;
    if (enRango || iso === calPrimerClic) clase += ' pnl-cal-sel';
    if (iso === fmtISO(new Date())) clase += ' pnl-cal-hoy';
    return clase;
  };

  const cerrarDetalleHistoriasVistas = () => {
    setDetalleHistoriasId(null);
    setDetalleHistoriasVistasData([]);
  };

  const cargarSaldos = async () => {
    setCargandoSaldos(true);
    setErrorSaldos('');
    try {
      const res = await fetch(`${process.env.REACT_APP_SALDO_DEV_URL}/admin_listar_saldos.php`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.success) {
        setSaldos(data.data);
      } else {
        setErrorSaldos(data.message || 'Error cargando saldos');
      }
    } catch (e) {
      console.error('Error cargando saldos:', e);
      setErrorSaldos('Error de conexion');
    } finally {
      setCargandoSaldos(false);
    }
  };

  const handleSeleccionarEstadoSaldo = (idSaldo, nuevoEstado) => {
    setSeleccionSaldos(prev => ({ ...prev, [idSaldo]: nuevoEstado }));
  };

  const handleEnviarEstadoSaldo = async (idSaldo) => {
    const nuevoEstado = seleccionSaldos[idSaldo];
    if (!nuevoEstado) return;

    setEnviandoSaldo(idSaldo);
    try {
      const res = await fetch(`${process.env.REACT_APP_SALDO_DEV_URL}/admin_actualizar_estado_saldo.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idSaldo, estado: nuevoEstado })
      });
      const data = await res.json();
      if (data.success) {
        setSaldos(prev => prev.map(s => s.id_saldo === idSaldo ? { ...s, ESTADO: nuevoEstado } : s));
        setSeleccionSaldos(prev => {
          const copia = { ...prev };
          delete copia[idSaldo];
          return copia;
        });
      } else {
        alert(data.message || 'No se pudo actualizar el estado');
      }
    } catch (e) {
      console.error('Error actualizando estado de saldo:', e);
      alert('Error de conexion al actualizar');
    } finally {
      setEnviandoSaldo(null);
    }
  };

  const abrirModalContenido = async (tipoOrigen, item) => {
    setModalContenido({
      abierto: true,
      tipoOrigen,
      item,
      cargando: true,
      fotos: [],
      videos: [],
      audios: [],
      fotoAmpliada: null,
      videoAmpliado: null,
      pantallaCompleta: null,
      pantallaCompletaTipo: null
    });

    try {
      const urlContenido = tipoOrigen === 'edicion'
        ? `${process.env.REACT_APP_ESTADO_EDICION_URL}/admin_listar_contenido_edicion.php?id_publicacion=${item.id_publicacion}`
        : `${process.env.REACT_APP_ESTADO_PUBLICACIONES_URL}/admin_listar_contenido.php?id_publicacion=${item.id_publicacion}&tipo=${tipoOrigen}`;

      const res = await fetch(urlContenido, { credentials: 'include' });
      const data = await res.json();
      if (data.success) {
        setModalContenido(prev => ({
          ...prev,
          cargando: false,
          fotos: data.data.fotos,
          videos: data.data.videos,
          audios: data.data.audios
        }));
      } else {
        setModalContenido(prev => ({ ...prev, cargando: false }));
        alert(data.message || 'No se pudo cargar el contenido');
      }
    } catch (e) {
      console.error('Error cargando contenido:', e);
      setModalContenido(prev => ({ ...prev, cargando: false }));
      alert('Error de conexion al cargar contenido');
    }
  };

  const cerrarModalContenido = () => {
    setModalContenido({
      abierto: false,
      tipoOrigen: null,
      item: null,
      cargando: false,
      fotos: [],
      videos: [],
      audios: [],
      fotoAmpliada: null,
      videoAmpliado: null,
      pantallaCompleta: null,
      pantallaCompletaTipo: null
    });
  };

  const abrirPantallaCompleta = (url, tipo) => {
    setModalContenido(prev => ({ ...prev, pantallaCompleta: url, pantallaCompletaTipo: tipo }));
  };

  const cerrarPantallaCompleta = () => {
    setModalContenido(prev => ({ ...prev, pantallaCompleta: null, pantallaCompletaTipo: null }));
  };

  const cargarVerificaciones = async () => {
    setCargandoVerificaciones(true);
    setErrorVerificaciones('');
    try {
      const res = await fetch(`${process.env.REACT_APP_ESTADO_VERIFICACION_URL}/admin_listar_verificaciones.php`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.success) {
        setVerificaciones(data.data);
      } else {
        setErrorVerificaciones(data.message || 'Error cargando verificaciones');
      }
    } catch (e) {
      console.error('Error cargando verificaciones:', e);
      setErrorVerificaciones('Error de conexion');
    } finally {
      setCargandoVerificaciones(false);
    }
  };

  const handleSeleccionarEstadoVerificacion = (idVerificacion, nuevoEstado) => {
    setSeleccionVerificaciones(prev => ({ ...prev, [idVerificacion]: nuevoEstado }));
  };

  const handleEnviarEstadoVerificacion = async (idVerificacion) => {
    const nuevoEstado = seleccionVerificaciones[idVerificacion];
    if (!nuevoEstado) return;

    setEnviandoVerificacion(idVerificacion);
    try {
      const res = await fetch(`${process.env.REACT_APP_ESTADO_VERIFICACION_URL}/admin_actualizar_estado_verificacion.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idVerificacion, estado: nuevoEstado })
      });
      const data = await res.json();
      if (data.success) {
        setVerificaciones(prev => prev.map(v => v.id_verificacion === idVerificacion ? { ...v, Estado: nuevoEstado } : v));
        setSeleccionVerificaciones(prev => {
          const copia = { ...prev };
          delete copia[idVerificacion];
          return copia;
        });
      } else {
        alert(data.message || 'No se pudo actualizar el estado');
      }
    } catch (e) {
      console.error('Error actualizando estado de verificacion:', e);
      alert('Error de conexion al actualizar');
    } finally {
      setEnviandoVerificacion(null);
    }
  };

  const [seleccionAvisos, setSeleccionAvisos] = useState({});
  const [enviandoAviso, setEnviandoAviso] = useState(null);

  const handleSeleccionarEstadoAviso = (idEstado, nuevoEstado) => {
    setSeleccionAvisos(prev => ({ ...prev, [idEstado]: nuevoEstado }));
  };

  const handleEnviarEstadoAviso = async (idEstado) => {
    const nuevoEstado = seleccionAvisos[idEstado];
    if (!nuevoEstado) return;

    setEnviandoAviso(idEstado);
    try {
      const res = await fetch(`${process.env.REACT_APP_ESTADO_PUBLICACIONES_URL}/admin_actualizar_estado_aviso.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idEstado, estado: nuevoEstado })
      });
      const data = await res.json();
      if (data.success) {
        setAvisos(prev => prev.map(a => a.id_estado === idEstado ? { ...a, Estado: nuevoEstado } : a));
        setSeleccionAvisos(prev => {
          const copia = { ...prev };
          delete copia[idEstado];
          return copia;
        });
      } else {
        alert(data.message || 'No se pudo actualizar el estado');
      }
    } catch (e) {
      console.error('Error actualizando estado:', e);
      alert('Error de conexion al actualizar');
    } finally {
      setEnviandoAviso(null);
    }
  };

  const cargarEdicionPublicaciones = async () => {
    setCargandoEdicion(true);
    setErrorEdicion('');
    try {
      const res = await fetch(`${process.env.REACT_APP_ESTADO_EDICION_URL}/admin_listar_edicion.php`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.success) {
        setEdicionPublicaciones(data.data);
      } else {
        setErrorEdicion(data.message || 'Error cargando ediciones');
      }
    } catch (e) {
      console.error('Error cargando ediciones:', e);
      setErrorEdicion('Error de conexion');
    } finally {
      setCargandoEdicion(false);
    }
  };

  const handleSeleccionarEstadoEdicion = (idEstado, nuevoEstado) => {
    setSeleccionEdicion(prev => ({ ...prev, [idEstado]: nuevoEstado }));
  };

  const handleEnviarEstadoEdicion = async (idEstado) => {
    const nuevoEstado = seleccionEdicion[idEstado];
    if (!nuevoEstado) return;

    setEnviandoEdicion(idEstado);
    try {
      const res = await fetch(`${process.env.REACT_APP_ESTADO_EDICION_URL}/admin_actualizar_estado_edicion.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idEstado, estado: nuevoEstado })
      });
      const data = await res.json();
      if (data.success) {
        setEdicionPublicaciones(prev => prev.map(ed => ed.id_estado === idEstado ? { ...ed, Estado: nuevoEstado } : ed));
        setSeleccionEdicion(prev => {
          const copia = { ...prev };
          delete copia[idEstado];
          return copia;
        });
      } else {
        alert(data.message || 'No se pudo actualizar el estado');
      }
    } catch (e) {
      console.error('Error actualizando estado de edicion:', e);
      alert('Error de conexion al actualizar');
    } finally {
      setEnviandoEdicion(null);
    }
  };

  const handleInspeccionar = async () => {
    const id = parseInt(idInspeccionar, 10);
    if (!id || id <= 0) {
      setMensajeInspeccionar('Ingresa un ID valido.');
      return;
    }
    setCargandoInspeccionar(true);
    setMensajeInspeccionar('');
    try {
      const res = await fetch(`${process.env.REACT_APP_AUTH_ADMIN_URL}/impersonar_usuario.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario_id: id })
      });
      const data = await res.json();
      if (data.success) {
        navigate('/panel_creador');
      } else {
        setMensajeInspeccionar(data.message || 'No se pudo entrar a esa cuenta.');
      }
    } catch (err) {
      setMensajeInspeccionar('Error de conexion.');
    } finally {
      setCargandoInspeccionar(false);
    }
  };


  const handleLogout = async () => {
    try {
      await fetch(`${process.env.REACT_APP_AUTH_ADMIN_URL}/logout.php`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (e) {
      console.error('Error cerrando sesion:', e);
    }
    navigate('/panel_admin_login');
  };

  return (
    <div className="pnl-wrapper">
      <nav className="pnl-nav">
        <div className="pnl-nav-item" data-active={seccion === 'inicio'} onClick={() => setSeccion('inicio')}>
          <i className="fas fa-home"></i>
          <span>Inicio</span>
        </div>
        <div className="pnl-nav-item" data-active={seccion === 'publicaciones'} onClick={() => setSeccion('publicaciones')}>
          <i className="fas fa-images"></i>
          <span>Publicaciones</span>
        </div>
        <div className="pnl-nav-item" data-active={seccion === 'estadisticas'} onClick={() => setSeccion('estadisticas')}>
          <i className="fas fa-chart-bar"></i>
          <span>Estadisticas</span>
        </div>
        <div className="pnl-nav-item" data-active={seccion === 'videos'} onClick={() => setSeccion('videos')}>
          <i className="fas fa-video"></i>
          <span>Videos</span>
        </div>
        <div className="pnl-nav-item" data-active={seccion === 'inspeccionar'} onClick={() => setSeccion('inspeccionar')}>
          <i className="fas fa-user-secret"></i>
          <span>Inspeccionar - Resolucion problemas</span>
        </div>
      </nav>

      <div className="pnl-main">
        <div className="pnl-topbar">
          <span>Sesion iniciada como: {nombreUsuario || '...'}</span>
          <button className="pnl-logout-btn" onClick={handleLogout}>Cerrar sesion</button>
        </div>

        <div className="pnl-content">
          {seccion === 'inicio' && (
            <div>
              <h2>Panel de administracion</h2>
              <p>Selecciona una seccion del menu para comenzar.</p>
            </div>
          )}

          {seccion === 'publicaciones' && (
            <div>
              <div className="pnl-tabs">
                <div className="pnl-tab" data-active={tabPublicaciones === 'avisos'} onClick={() => setTabPublicaciones('avisos')}>Avisos</div>
                <div className="pnl-tab" data-active={tabPublicaciones === 'verificacion'} onClick={() => setTabPublicaciones('verificacion')}>Verificacion</div>
                <div className="pnl-tab" data-active={tabPublicaciones === 'saldo'} onClick={() => setTabPublicaciones('saldo')}>Saldo</div>
                <div className="pnl-tab" data-active={tabPublicaciones === 'edicion'} onClick={() => setTabPublicaciones('edicion')}>Edicion Publicacion</div>
              </div>
              <div className="pnl-tab-content">
                {tabPublicaciones === 'avisos' && (
                  <div>
                    {cargandoAvisos && <p>Cargando...</p>}
                    {errorAvisos && <p className="pnl-error">{errorAvisos}</p>}
                    {!cargandoAvisos && !errorAvisos && (
                      <>
                        <table className="pnl-tabla">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Nombre</th>
                              <th>Plan</th>
                              <th>Ticket</th>
                              <th>Fecha</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {avisos
                              .slice((paginaAvisos - 1) * AVISOS_POR_PAGINA, paginaAvisos * AVISOS_POR_PAGINA)
                              .map(aviso => (
                              <tr key={aviso.id_estado}>
                                <td data-label="ID">{aviso.id_publicacion}</td>
                                <td data-label="Nombre">{aviso.nombre}</td>
                                <td data-label="Plan">{aviso.PLAN_ESTADO_GES_AVIS || '-'}</td>
                                <td data-label="Ticket">{aviso.Ticket}</td>
                                <td data-label="Fecha">{aviso.Fecha_ingreso}</td>
                                <td data-label="Estado">
                                  <div className="pnl-estado-accion">
                                    <button
                                      className="pnl-btn-ojo"
                                      onClick={() => abrirModalContenido('avisos', aviso)}
                                      title="Revisar contenido"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                    <select
                                      className={getClaseEstado(seleccionAvisos[aviso.id_estado] ?? aviso.Estado)}
                                      value={seleccionAvisos[aviso.id_estado] ?? aviso.Estado}
                                      onChange={(e) => handleSeleccionarEstadoAviso(aviso.id_estado, e.target.value)}
                                    >
                                      <option value="Pendiente">Pendiente</option>
                                      <option value="Aprobada">Aprobada</option>
                                      <option value="Rechazada">Rechazada</option>
                                    </select>
                                    {seleccionAvisos[aviso.id_estado] && seleccionAvisos[aviso.id_estado] !== aviso.Estado && (
                                      <button
                                        className="pnl-btn-enviar"
                                        disabled={enviandoAviso === aviso.id_estado}
                                        onClick={() => handleEnviarEstadoAviso(aviso.id_estado)}
                                      >
                                        {enviandoAviso === aviso.id_estado ? '...' : 'Enviar'}
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="pnl-paginacion">
                          <button
                            disabled={paginaAvisos === 1}
                            onClick={() => setPaginaAvisos(p => p - 1)}
                          >
                            Anterior
                          </button>
                          <span>Pagina {paginaAvisos} de {Math.max(1, Math.ceil(avisos.length / AVISOS_POR_PAGINA))}</span>
                          <button
                            disabled={paginaAvisos * AVISOS_POR_PAGINA >= avisos.length}
                            onClick={() => setPaginaAvisos(p => p + 1)}
                          >
                            Siguiente
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {tabPublicaciones === 'verificacion' && (
                  <div>
                    {cargandoVerificaciones && <p>Cargando...</p>}
                    {errorVerificaciones && <p className="pnl-error">{errorVerificaciones}</p>}
                    {!cargandoVerificaciones && !errorVerificaciones && (
                      <>
                        <table className="pnl-tabla">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Nombre</th>
                              <th>Plan</th>
                              <th>Ticket</th>
                              <th>Fecha</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {verificaciones
                              .slice((paginaVerificaciones - 1) * AVISOS_POR_PAGINA, paginaVerificaciones * AVISOS_POR_PAGINA)
                              .map(v => (
                              <tr key={v.id_verificacion}>
                                <td data-label="ID">{v.id_publicacion}</td>
                                <td data-label="Nombre">{v.nombre}</td>
                                <td data-label="Plan">{v.PLAN_ESTADO_GES_AVIS || '-'}</td>
                                <td data-label="Ticket">{v.Ticket}</td>
                                <td data-label="Fecha">{v.Fecha_ingreso}</td>
                                <td data-label="Estado">
                                  <div className="pnl-estado-accion">
                                    <button
                                      className="pnl-btn-ojo"
                                      onClick={() => abrirModalContenido('verificacion', v)}
                                      title="Revisar contenido"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                    <select
                                      className={getClaseEstado(seleccionVerificaciones[v.id_verificacion] ?? v.Estado)}
                                      value={seleccionVerificaciones[v.id_verificacion] ?? v.Estado}
                                      onChange={(e) => handleSeleccionarEstadoVerificacion(v.id_verificacion, e.target.value)}
                                    >
                                      <option value="Pendiente">Pendiente</option>
                                      <option value="Aprobada">Aprobada</option>
                                      <option value="Rechazada">Rechazada</option>
                                    </select>
                                    {seleccionVerificaciones[v.id_verificacion] && seleccionVerificaciones[v.id_verificacion] !== v.Estado && (
                                      <button
                                        className="pnl-btn-enviar"
                                        disabled={enviandoVerificacion === v.id_verificacion}
                                        onClick={() => handleEnviarEstadoVerificacion(v.id_verificacion)}
                                      >
                                        {enviandoVerificacion === v.id_verificacion ? '...' : 'Enviar'}
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="pnl-paginacion">
                          <button
                            disabled={paginaVerificaciones === 1}
                            onClick={() => setPaginaVerificaciones(p => p - 1)}
                          >
                            Anterior
                          </button>
                          <span>Pagina {paginaVerificaciones} de {Math.max(1, Math.ceil(verificaciones.length / AVISOS_POR_PAGINA))}</span>
                          <button
                            disabled={paginaVerificaciones * AVISOS_POR_PAGINA >= verificaciones.length}
                            onClick={() => setPaginaVerificaciones(p => p + 1)}
                          >
                            Siguiente
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {tabPublicaciones === 'saldo' && (
                  <div>
                    {cargandoSaldos && <p>Cargando...</p>}
                    {errorSaldos && <p className="pnl-error">{errorSaldos}</p>}
                    {!cargandoSaldos && !errorSaldos && (
                      <>
                        <table className="pnl-tabla">
                          <thead>
                            <tr>
                              <th>ID Usuario</th>
                              <th>Nombre usuario</th>
                              <th>Saldo anadido</th>
                              <th>Saldo actual</th>
                              <th>Fecha</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {saldos
                              .slice((paginaSaldos - 1) * AVISOS_POR_PAGINA, paginaSaldos * AVISOS_POR_PAGINA)
                              .map(s => (
                              <tr key={s.id_saldo}>
                                <td data-label="ID Usuario">{s.ID_usuario}</td>
                                <td data-label="Nombre usuario">{s.nombre_usuario || '-'}</td>
                                <td data-label="Saldo anadido">${Number(s.Saldo_anadido || 0).toLocaleString('es-CL')}</td>
                                <td data-label="Saldo actual">${Number(s.saldo_actual || 0).toLocaleString('es-CL')}</td>
                                <td data-label="Fecha">{s.Fecha_anadir_saldo}</td>
                                <td data-label="Estado">
                                  <div className="pnl-estado-accion">
                                    <select
                                      className={getClaseEstado(seleccionSaldos[s.id_saldo] ?? s.ESTADO)}
                                      value={seleccionSaldos[s.id_saldo] ?? s.ESTADO}
                                      onChange={(e) => handleSeleccionarEstadoSaldo(s.id_saldo, e.target.value)}
                                    >
                                      <option value="PENDIENTE">Pendiente</option>
                                      <option value="APROBADA">Aprobada</option>
                                      <option value="RECHAZADA">Rechazada</option>
                                    </select>
                                    {seleccionSaldos[s.id_saldo] && seleccionSaldos[s.id_saldo] !== s.ESTADO && (
                                      <button
                                        className="pnl-btn-enviar"
                                        disabled={enviandoSaldo === s.id_saldo}
                                        onClick={() => handleEnviarEstadoSaldo(s.id_saldo)}
                                      >
                                        {enviandoSaldo === s.id_saldo ? '...' : 'Enviar'}
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="pnl-paginacion">
                          <button
                            disabled={paginaSaldos === 1}
                            onClick={() => setPaginaSaldos(p => p - 1)}
                          >
                            Anterior
                          </button>
                          <span>Pagina {paginaSaldos} de {Math.max(1, Math.ceil(saldos.length / AVISOS_POR_PAGINA))}</span>
                          <button
                            disabled={paginaSaldos * AVISOS_POR_PAGINA >= saldos.length}
                            onClick={() => setPaginaSaldos(p => p + 1)}
                          >
                            Siguiente
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {tabPublicaciones === 'edicion' && (
                  <div>
                    {cargandoEdicion && <p>Cargando...</p>}
                    {errorEdicion && <p className="pnl-error">{errorEdicion}</p>}
                    {!cargandoEdicion && !errorEdicion && (
                      <>
                        <table className="pnl-tabla">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Nombre</th>
                              <th>Ticket</th>
                              <th>Fecha</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {edicionPublicaciones
                              .slice((paginaEdicion - 1) * AVISOS_POR_PAGINA, paginaEdicion * AVISOS_POR_PAGINA)
                              .map(ed => (
                              <tr key={ed.id_estado}>
                                <td data-label="ID">{ed.id_publicacion}</td>
                                <td data-label="Nombre">{ed.nombre}</td>
                                <td data-label="Ticket">{ed.Ticket}</td>
                                <td data-label="Fecha">{ed.Fecha_ingreso}</td>
                                <td data-label="Estado">
                                  <div className="pnl-estado-accion">
                                    <button
                                      className="pnl-btn-ojo"
                                      onClick={() => abrirModalContenido('edicion', ed)}
                                      title="Revisar contenido nuevo"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                    <select
                                      className={getClaseEstado(seleccionEdicion[ed.id_estado] ?? ed.Estado)}
                                      value={seleccionEdicion[ed.id_estado] ?? ed.Estado}
                                      onChange={(e) => handleSeleccionarEstadoEdicion(ed.id_estado, e.target.value)}
                                    >
                                      <option value="Pendiente">Pendiente</option>
                                      <option value="Aprobada">Aprobada</option>
                                      <option value="Rechazada">Rechazada</option>
                                    </select>
                                    {seleccionEdicion[ed.id_estado] && seleccionEdicion[ed.id_estado] !== ed.Estado && (
                                      <button
                                        className="pnl-btn-enviar"
                                        disabled={enviandoEdicion === ed.id_estado}
                                        onClick={() => handleEnviarEstadoEdicion(ed.id_estado)}
                                      >
                                        {enviandoEdicion === ed.id_estado ? '...' : 'Enviar'}
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="pnl-paginacion">
                          <button
                            disabled={paginaEdicion === 1}
                            onClick={() => setPaginaEdicion(p => p - 1)}
                          >
                            Anterior
                          </button>
                          <span>Pagina {paginaEdicion} de {Math.max(1, Math.ceil(edicionPublicaciones.length / AVISOS_POR_PAGINA))}</span>
                          <button
                            disabled={paginaEdicion * AVISOS_POR_PAGINA >= edicionPublicaciones.length}
                            onClick={() => setPaginaEdicion(p => p + 1)}
                          >
                            Siguiente
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {seccion === 'estadisticas' && (
            <div>
              <h2>Estadisticas de contacto</h2>
              <form onSubmit={handleBuscarClicks} className="pnl-form-video" style={{flexDirection:'row', maxWidth:'500px'}}>
                <input
                  type="text"
                  placeholder="Buscar por ID o nombre"
                  value={busquedaClicks}
                  onChange={(e) => setBusquedaClicks(e.target.value)}
                />
                <button type="submit" className="pnl-btn-enviar">Buscar</button>
              </form>

              {cargandoClicks && <p>Cargando...</p>}
              {!cargandoClicks && (
                <table className="pnl-tabla">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Whatsapp</th>
                      <th>Llamada</th>
                      <th>Telegram</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {clicksTotales.map(c => (
                      <tr key={c.id_publicacion}>
                        <td data-label="ID">{c.id_publicacion}</td>
                        <td data-label="Nombre">{c.nombre}</td>
                        <td data-label="Whatsapp">{c.whatsapp}</td>
                        <td data-label="Llamada">{c.llamada}</td>
                        <td data-label="Telegram">{c.telegram}</td>
                        <td data-label="">
                          <button className="pnl-btn-vertexto" onClick={() => verDetalleClicks(c.id_publicacion, 'dia')}>
                            Ver detalle
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {detalleClicksId && (
                <div className="pnl-video-item" style={{marginTop:'16px'}}>
                  <div className="pnl-estado-accion">
                    <p style={{margin:0}}>Detalle ID {detalleClicksId} - agrupado por:</p>
                    <button
                      className={detalleClicksAgrupar === 'dia' ? 'pnl-btn-enviar' : 'pnl-btn-ojo'}
                      onClick={() => verDetalleClicks(detalleClicksId, 'dia')}
                    >
                      Día
                    </button>
                    <button
                      className={detalleClicksAgrupar === 'semana' ? 'pnl-btn-enviar' : 'pnl-btn-ojo'}
                      onClick={() => verDetalleClicks(detalleClicksId, 'semana')}
                    >
                      Semana
                    </button>
                    <button
                      className={detalleClicksAgrupar === 'mes' ? 'pnl-btn-enviar' : 'pnl-btn-ojo'}
                      onClick={() => verDetalleClicks(detalleClicksId, 'mes')}
                    >
                      Mes
                    </button>
                    <button className="pnl-btn-vertexto" onClick={cerrarDetalleClicks}>Cerrar</button>
                  </div>

                  {cargandoDetalleClicks && <p>Cargando...</p>}
                  {!cargandoDetalleClicks && (
                    <table className="pnl-tabla">
                      <thead>
                        <tr>
                          <th>Periodo</th>
                          <th>Whatsapp</th>
                          <th>Llamada</th>
                          <th>Telegram</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detalleClicksData.map(d => (
                          <tr key={d.periodo}>
                            <td data-label="Periodo">
                              {detalleClicksAgrupar === 'dia'
                                ? formatDiaCompleto(d.fecha_inicio)
                                : detalleClicksAgrupar === 'semana'
                                ? formatRangoSemana(d.fecha_inicio)
                                : new Date(d.fecha_inicio).toLocaleDateString('es-CL', { month: 'long', year: 'numeric' })}
                            </td>
                            <td data-label="Whatsapp">{d.whatsapp}</td>
                            <td data-label="Llamada">{d.llamada}</td>
                            <td data-label="Telegram">{d.telegram}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}

              <h2 style={{marginTop:'32px'}}>Vistas de historias</h2>
              <form onSubmit={handleBuscarHistoriasVistas} className="pnl-form-video" style={{flexDirection:'row', maxWidth:'500px'}}>
                <input
                  type="text"
                  placeholder="Buscar por ID o nombre"
                  value={busquedaHistoriasVistas}
                  onChange={(e) => setBusquedaHistoriasVistas(e.target.value)}
                />
                <button type="submit" className="pnl-btn-enviar">Buscar</button>
              </form>

              {cargandoHistoriasVistas && <p>Cargando...</p>}
              {!cargandoHistoriasVistas && (
                <table className="pnl-tabla">
                  <thead>
                    <tr>
                      <th>ID Usuario</th>
                      <th>Nombre</th>
                      <th>Foto</th>
                      <th>Video</th>
                      <th>Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {historiasVistasTotales.map(h => (
                      <tr key={h.usuario_id}>
                        <td data-label="ID Usuario">{h.usuario_id}</td>
                        <td data-label="Nombre">{h.nombre}</td>
                        <td data-label="Foto">{h.foto}</td>
                        <td data-label="Video">{h.video}</td>
                        <td data-label="Total">{h.total}</td>
                        <td data-label="">
                          <button className="pnl-btn-vertexto" onClick={() => verUltimos3DiasHistorias(h.usuario_id)}>
                            Ver detalle
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {detalleHistoriasId && (
                <div className="pnl-video-item" style={{marginTop:'16px'}}>
                  <div className="pnl-estado-accion">
                    <p style={{margin:0}}>Detalle usuario {detalleHistoriasId}:</p>
                    <button
                      className={detalleHistoriasAgrupar === 'ultimos3' ? 'pnl-btn-enviar' : 'pnl-btn-periodo'}
                      onClick={() => verUltimos3DiasHistorias(detalleHistoriasId)}
                    >
                      {'\u00daltimos 3 d\u00edas'}
                    </button>
                    <button
                      className={detalleHistoriasAgrupar === 'dia' ? 'pnl-btn-enviar' : 'pnl-btn-periodo'}
                      onClick={() => verDetalleHistoriasVistas(detalleHistoriasId, 'dia')}
                    >
                      {'D\u00eda'}
                    </button>
                    <button
                      className={(detalleHistoriasAgrupar === 'semana' || detalleHistoriasAgrupar === 'rango') ? 'pnl-btn-enviar' : 'pnl-btn-periodo'}
                      onClick={() => abrirSemanaHistorias(detalleHistoriasId)}
                    >
                      Semana
                    </button>
                    <button
                      className={detalleHistoriasAgrupar === 'mes' ? 'pnl-btn-enviar' : 'pnl-btn-periodo'}
                      onClick={() => verDetalleHistoriasVistas(detalleHistoriasId, 'mes')}
                    >
                      Mes
                    </button>
                    <button className="pnl-btn-vertexto" onClick={cerrarDetalleHistoriasVistas}>Cerrar</button>
                  </div>

                  {(detalleHistoriasAgrupar === 'semana' || detalleHistoriasAgrupar === 'rango') && (
                    <div className="pnl-calendario">
                      <div className="pnl-cal-cabecera">
                        <button type="button" className="pnl-btn-periodo" onClick={() => setCalMes(new Date(calMes.getFullYear(), calMes.getMonth() - 1, 1))}>&lt;</button>
                        <span className="pnl-cal-titulo">{calMes.toLocaleDateString('es-CL', { month: 'long', year: 'numeric' })}</span>
                        <button type="button" className="pnl-btn-periodo" onClick={() => setCalMes(new Date(calMes.getFullYear(), calMes.getMonth() + 1, 1))}>&gt;</button>
                        <button type="button" className="pnl-btn-periodo" onClick={seleccionarSemanaCompleta}>Semana completa</button>
                      </div>
                      <div className="pnl-cal-grid">
                        {['L', 'M', 'M', 'J', 'V', 'S', 'D'].map((n, i) => (
                          <div key={'n' + i} className="pnl-cal-nombre">{n}</div>
                        ))}
                        {diasDelCalendario().map((iso, i) => (
                          iso ? (
                            <button type="button" key={iso} className={claseDiaCalendario(iso)} onClick={() => clicDiaCalendario(iso)}>
                              {parseInt(iso.slice(8), 10)}
                            </button>
                          ) : (
                            <div key={'v' + i} />
                          )
                        ))}
                      </div>
                      <p className="pnl-cal-ayuda">{'Clic en un d\u00eda = 1 d\u00eda. Segundo clic = rango. "Semana completa" = lunes a domingo.'}</p>
                    </div>
                  )}

                  {cargandoDetalleHistoriasVistas && <p>Cargando...</p>}
                  {!cargandoDetalleHistoriasVistas && (
                    <table className="pnl-tabla">
                      <thead>
                        <tr>
                          <th>Periodo</th>
                          <th>Foto</th>
                          <th>Video</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detalleHistoriasVistasData.map(d => (
                          <tr key={d.periodo}>
                            <td data-label="Periodo">
                              {detalleHistoriasAgrupar === 'semana'
                                ? formatRangoSemana(d.fecha_inicio)
                                : detalleHistoriasAgrupar === 'mes'
                                ? new Date(d.fecha_inicio + 'T00:00:00').toLocaleDateString('es-CL', { month: 'long', year: 'numeric' })
                                : formatDiaCompleto(d.fecha_inicio)}
                            </td>
                            <td data-label="Foto">{d.foto}</td>
                            <td data-label="Video">{d.video}</td>
                          </tr>
                        ))}
                        {(detalleHistoriasAgrupar === 'ultimos3' || detalleHistoriasAgrupar === 'rango') && (
                          <tr>
                            <td data-label="Periodo"><strong>Total</strong></td>
                            <td data-label="Foto"><strong>{detalleHistoriasVistasData.reduce((s, d) => s + Number(d.foto), 0)}</strong></td>
                            <td data-label="Video"><strong>{detalleHistoriasVistasData.reduce((s, d) => s + Number(d.video), 0)}</strong></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          )}

          {seccion === 'videos' && (
            <div>
              <h2>Videos principales</h2>

              <form onSubmit={handleSubirVideo} className="pnl-form-video">
                {mensajeVideo && <p className="pnl-error">{mensajeVideo}</p>}
                <input
                  type="text"
                  placeholder="Titulo"
                  value={tituloVideo}
                  onChange={(e) => setTituloVideo(e.target.value)}
                  disabled={subiendoVideo}
                />
                <textarea
                  placeholder="Descripcion"
                  value={descripcionVideo}
                  onChange={(e) => setDescripcionVideo(e.target.value)}
                  disabled={subiendoVideo}
                />
                <input
                  type="file"
                  accept="video/mp4,video/quicktime,video/webm"
                  onChange={(e) => setArchivoVideo(e.target.files[0] || null)}
                  disabled={subiendoVideo}
                />
                <button type="submit" className="pnl-btn-enviar" disabled={subiendoVideo}>
                  {subiendoVideo ? 'Subiendo...' : 'Subir video'}
                </button>
              </form>

              {cargandoVideos && <p>Cargando...</p>}
              {!cargandoVideos && videos.map(video => (
                <div key={video.ID} className="pnl-video-item">
                  {editandoVideoId === video.ID ? (
                    <>
                      <input value={tituloEdicion} onChange={(e) => setTituloEdicion(e.target.value)} />
                      <textarea value={descripcionEdicion} onChange={(e) => setDescripcionEdicion(e.target.value)} />
                      <div className="pnl-estado-accion">
                        <button className="pnl-btn-enviar" onClick={guardarEdicionVideo}>Guardar</button>
                        <button className="pnl-btn-ojo" onClick={() => setEditandoVideoId(null)}>Cancelar</button>
                      </div>
                    </>
                  ) : (
                    <>
                      <p><strong>{video.Titulo}</strong> ({video.Visualizaciones} visualizaciones)</p>
                      <p>{video.Descripcion}</p>
                      <div className="pnl-estado-accion">
                        <button className="pnl-btn-ojo" onClick={() => iniciarEdicionVideo(video)}>
                          <i className="fas fa-pen"></i>
                        </button>
                        <button className="pnl-btn-eliminar" onClick={() => handleEliminarVideo(video)}>
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {seccion === 'inspeccionar' && (
            <div>
              <h2>Inspeccionar - Resolucion problemas</h2>
              <p>Entra a la cuenta de una creadora para diagnosticar un problema reportado.</p>
              {mensajeInspeccionar && <p className="pnl-error">{mensajeInspeccionar}</p>}
              <input
                type="number"
                placeholder="ID de la usuaria"
                value={idInspeccionar}
                onChange={(e) => setIdInspeccionar(e.target.value)}
              />
              <button onClick={handleInspeccionar} disabled={cargandoInspeccionar}>
                {cargandoInspeccionar ? 'Entrando...' : 'Entrar como esta usuaria'}
              </button>
            </div>
          )}
        </div>
      </div>

      {modalContenido.abierto && (
        <div className="pnl-modal-overlay" onClick={cerrarModalContenido}>
          <div className="pnl-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pnl-modal-header">
              <span>Contenido - ID {modalContenido.item?.id_publicacion} ({modalContenido.item?.nombre})</span>
              <i className="fas fa-times pnl-modal-cerrar" onClick={cerrarModalContenido}></i>
            </div>

            {modalContenido.cargando && <p>Cargando contenido...</p>}

            {!modalContenido.cargando && (
              <>
                {modalContenido.fotoAmpliada && (
                  <div className="pnl-foto-ampliada">
                    <img src={modalContenido.fotoAmpliada} alt="Vista ampliada" />
                    <button
                      className="pnl-btn-pantalla-completa"
                      onClick={() => abrirPantallaCompleta(modalContenido.fotoAmpliada, 'foto')}
                    >
                      Pantalla completa
                    </button>
                  </div>
                )}

                <p className="pnl-modal-subtitulo">Fotos ({modalContenido.fotos.length})</p>
                <div className="pnl-modal-grid">
                  {modalContenido.fotos.map(f => {
                    const urlFoto = construirUrlUpload(modalContenido.item.id_publicacion, modalContenido.tipoOrigen, f);
                    return (
                      <img
                        key={f}
                        className={`pnl-modal-thumb${modalContenido.fotoAmpliada === urlFoto ? ' pnl-thumb-activo' : ''}`}
                        src={urlFoto}
                        alt={f}
                        onClick={() => setModalContenido(prev => ({ ...prev, fotoAmpliada: urlFoto }))}
                      />
                    );
                  })}
                  {modalContenido.fotos.length === 0 && <p className="pnl-modal-vacio">Sin fotos</p>}
                </div>

                <div className="pnl-separador-amarillo"></div>

                <p className="pnl-modal-subtitulo">Videos ({modalContenido.videos.length})</p>
                <div className="pnl-modal-grid">
                  {modalContenido.videos.map(v => {
                    const urlVideo = construirUrlUpload(modalContenido.item.id_publicacion, modalContenido.tipoOrigen, v);
                    return (
                      <video
                        key={v}
                        className={`pnl-modal-thumb${modalContenido.videoAmpliado === urlVideo ? ' pnl-thumb-activo' : ''}`}
                        preload="metadata"
                        muted
                        onClick={() => setModalContenido(prev => ({ ...prev, videoAmpliado: urlVideo }))}
                      >
                        <source src={urlVideo} />
                      </video>
                    );
                  })}
                  {modalContenido.videos.length === 0 && <p className="pnl-modal-vacio">Sin videos</p>}
                </div>

                {modalContenido.videoAmpliado && (
                  <div className="pnl-foto-ampliada">
                    <video src={modalContenido.videoAmpliado} controls autoPlay />
                    <button
                      className="pnl-btn-pantalla-completa"
                      onClick={() => abrirPantallaCompleta(modalContenido.videoAmpliado, 'video')}
                    >
                      Pantalla completa
                    </button>
                  </div>
                )}

                <div className="pnl-separador-amarillo"></div>

                {(modalContenido.tipoOrigen === 'avisos' || modalContenido.tipoOrigen === 'edicion') && (
                  <>
                    <p className="pnl-modal-subtitulo">Audio ({modalContenido.audios.length})</p>
                    <div className="pnl-modal-audios">
                      {modalContenido.audios.map(a => (
                        <audio key={a} controls preload="none" className="pnl-modal-audio">
                          <source src={construirUrlUpload(modalContenido.item.id_publicacion, modalContenido.tipoOrigen, a)} />
                        </audio>
                      ))}
                      {modalContenido.audios.length === 0 && <p className="pnl-modal-vacio">Sin audio</p>}
                    </div>
                  </>
                )}

                <div className="pnl-modal-estado">
                  <span>Estado:</span>
                  {modalContenido.tipoOrigen === 'avisos' ? (
                    <>
                      <select
                        className={getClaseEstado(seleccionAvisos[modalContenido.item.id_estado] ?? modalContenido.item.Estado)}
                        value={seleccionAvisos[modalContenido.item.id_estado] ?? modalContenido.item.Estado}
                        onChange={(e) => handleSeleccionarEstadoAviso(modalContenido.item.id_estado, e.target.value)}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Aprobada">Aprobada</option>
                        <option value="Rechazada">Rechazada</option>
                      </select>
                      {seleccionAvisos[modalContenido.item.id_estado] && seleccionAvisos[modalContenido.item.id_estado] !== modalContenido.item.Estado && (
                        <button
                          className="pnl-btn-enviar"
                          disabled={enviandoAviso === modalContenido.item.id_estado}
                          onClick={() => handleEnviarEstadoAviso(modalContenido.item.id_estado)}
                        >
                          {enviandoAviso === modalContenido.item.id_estado ? '...' : 'Enviar'}
                        </button>
                      )}
                    </>
                  ) : modalContenido.tipoOrigen === 'edicion' ? (
                    <>
                      <select
                        className={getClaseEstado(seleccionEdicion[modalContenido.item.id_estado] ?? modalContenido.item.Estado)}
                        value={seleccionEdicion[modalContenido.item.id_estado] ?? modalContenido.item.Estado}
                        onChange={(e) => handleSeleccionarEstadoEdicion(modalContenido.item.id_estado, e.target.value)}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Aprobada">Aprobada</option>
                        <option value="Rechazada">Rechazada</option>
                      </select>
                      {seleccionEdicion[modalContenido.item.id_estado] && seleccionEdicion[modalContenido.item.id_estado] !== modalContenido.item.Estado && (
                        <button
                          className="pnl-btn-enviar"
                          disabled={enviandoEdicion === modalContenido.item.id_estado}
                          onClick={() => handleEnviarEstadoEdicion(modalContenido.item.id_estado)}
                        >
                          {enviandoEdicion === modalContenido.item.id_estado ? '...' : 'Enviar'}
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      <select
                        className={getClaseEstado(seleccionVerificaciones[modalContenido.item.id_verificacion] ?? modalContenido.item.Estado)}
                        value={seleccionVerificaciones[modalContenido.item.id_verificacion] ?? modalContenido.item.Estado}
                        onChange={(e) => handleSeleccionarEstadoVerificacion(modalContenido.item.id_verificacion, e.target.value)}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Aprobada">Aprobada</option>
                        <option value="Rechazada">Rechazada</option>
                      </select>
                      {seleccionVerificaciones[modalContenido.item.id_verificacion] && seleccionVerificaciones[modalContenido.item.id_verificacion] !== modalContenido.item.Estado && (
                        <button
                          className="pnl-btn-enviar"
                          disabled={enviandoVerificacion === modalContenido.item.id_verificacion}
                          onClick={() => handleEnviarEstadoVerificacion(modalContenido.item.id_verificacion)}
                        >
                          {enviandoVerificacion === modalContenido.item.id_verificacion ? '...' : 'Enviar'}
                        </button>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          {modalContenido.pantallaCompleta && (
            <div className="pnl-overlay-completo" onClick={(e) => { e.stopPropagation(); cerrarPantallaCompleta(); }}>
              <i className="fas fa-times pnl-overlay-cerrar" onClick={(e) => { e.stopPropagation(); cerrarPantallaCompleta(); }}></i>
              {modalContenido.pantallaCompletaTipo === 'video' ? (
                <video src={modalContenido.pantallaCompleta} controls autoPlay onClick={(e) => e.stopPropagation()} />
              ) : (
                <img src={modalContenido.pantallaCompleta} alt="Pantalla completa" onClick={(e) => e.stopPropagation()} />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PanelAdmin;
